export enum ChildrenExpandState {
    EXPAND_CHILDREN = "EXPAND_CHILDREN",
    COLLAPSE_CHILDREN = "COLLAPSE_CHILDREN"
}
